<template>
  <button v-if="isAgentLoaded" class="ask-something-else" @click="handleCustomPromptAskMacys">
    <span class="spark-icon"></span>
    {{ hasGooglePrompts ? 'Ask something else' : 'Ask a question' }}
  </button>

  <Skeleton v-else-if="isAgentSkeleton" class="ask-something-else-skeleton" height="36px" width="150px" border-radius="20px" />
</template>

<script setup>
import Skeleton from '@atomic-ui/skeleton/Skeleton';
import { fireLinkTag } from '~/features/analytics/tagManager';
import useKillswitches from '~/modules/featureControl/composables/useKillswitches';

defineProps({
  isAgentLoaded: {
    type: Boolean,
    default: false,
  },
  isAgentSkeleton: {
    type: Boolean,
    default: false,
  },
  hasGooglePrompts: {
    type: Boolean,
    default: false,
  },
});

const { killswitches } = useKillswitches();

let customPromptTagFired = false;

const handleCustomPromptAskMacys = () => {
  const tagName = 'ask ai:open chat:product details:ask something else';
  if (window.googleAgent) {
    if (killswitches.featureEnabledF || !customPromptTagFired) {
      fireLinkTag({
        event_name: tagName,
        link_name: tagName,
      });
      customPromptTagFired = true;
    }
    window.googleAgent.openChat({ source: 'ASK_AI_SOURCE_CUSTOM_PDP_PROMPT' });
  } else {
    window.googleAgentOpen = true;
    window.dispatchEvent(new CustomEvent('google-agent-open'));
  }
};
</script>

<style lang="scss" scoped brand="mcom">
@import '~settingSCSS';

.spark-icon {
  display: inline-block;
  width: rem-calc(16);
  height: rem-calc(16);
  background-size: contain;
  background-repeat: no-repeat;
}

.ask-something-else {
  display: flex;
  flex: 0 0 auto;
  padding: 8px 16px 8px 8px;
  align-items: center;
  gap: 4px;
  border-radius: 20px;
  border: 1px solid transparent;

  background: $white;
  background-image: linear-gradient($white, $white), linear-gradient(90deg, #e01a2b 0%, #9747ff 100%);

  background-origin: border-box;
  background-clip: padding-box, border-box;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-image: linear-gradient($background-color, $background-color), linear-gradient(90deg, #e01a2b 0%, #9747ff 100%);
  }
}

.ask-something-else-skeleton {
  flex: 0 0 auto;
}
</style>
